import { createContext } from "react"

const userContext = createContext({
  user: {},
  login: () => { },
  logout: () => { },
  hasRole: (name) => { },
})

export const UserRole = {
  Admin: "SUPERADMIN",
  Vedouci: "ADMIN",
  Technik: "SUPERVISOR",
  Pracovnik: "USER",
  TzvVedouci: "TZV_ADMIN",
  TzvTechnik: "TZV_SUPERVISOR",
  TzvPracovnik: "TZV_USER"
}

export default userContext
